// extracted by mini-css-extract-plugin
export default {"container":"SummarizeMoreButton_container__tHeTj","button":"SummarizeMoreButton_button__cruin"};